import React, { Component } from 'react'
import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
// import Button from 'components/Button'
import HeadingBanner from 'components/Text/HeadingBanner'
import Crumbs from 'components/BreadCrumbs/Crumbs'
import SettingsForm from './SettingsForm.container'

import cn from 'classnames'
import s from './Settings.scss'
import sText from 'components/Text/Text.scss'
// import sAnim from 'components/Animation/Animation.scss'

export default class Settings extends Component {
  render() {
    const { user /*, submit, savePending*/ } = this.props

    // const absChildren = (
    //   <Button
    //     color="tertiary"
    //     className={sAnim.fromBottom}
    //     stickyBottom
    //     loading={savePending}
    //     onClick={() => submit('settingsForm')}
    //   >
    //     Update
    //   </Button>
    // )

    return (
      <Page
        layout={{ header: 'app' }}
        title="Settings"
        className={s.page}
        // absChildren={absChildren}
      >
        <PageHeader>
          <Crumbs title="Settings" />
          <HeadingBanner>
            <h3 className={cn(sText.heading3, sText.accent)}>
              {user.firstName} {user.lastName}
            </h3>
            <div className={sText.descrip2}>Update your details below if needed</div>
          </HeadingBanner>
        </PageHeader>

        <div className={s.formSection}>
          <Container className="sm">
            <SettingsForm user={user} />
          </Container>
        </div>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Settings/Settings.jsx